@if (type === SelectorType.CONTEXT) {
  <div>
    <button class="btn menu-btn" (click)="toggleShowMenu()"></button>
  </div>
  @if (showMenu) {
    <div>
      <div class="menu-container">
        <ul>
          @for (item of itemsSource; track item) {
            <li class="menu-item context-line-height" (click)="select(item.id)">
              <i class="menu-item-content">
                <div class="menu-item-caption">{{ item.textId | translate }}</div>
                @if (item.id === selectedItem.id) {
                  <img class="menu-item-icon" src="assets/icons/toolbar/check.svg" />
                }
              </i>
            </li>
          }
        </ul>
      </div>
    </div>
  }
}

@if (type === SelectorType.SLIDER) {
  <a class="menu-item" (click)="toggleShowMenu()">
    <img src="assets/icons/toolbar/language.svg" class="menu-item-icon" />
    {{ selectedItem.textId | translate }}
    <img src="assets/icons/angle.svg" class="menu-item-angle" [ngClass]="{ rotate: showMenu }" />
  </a>
  <div class="language-dropdown-content" [ngClass]="{ show: showMenu }">
    <ul>
      @for (item of itemsSourceWithoutSelected; track item) {
        <li (click)="select(item.id)">
          <i class="language-menu-item">
            {{ item.textId | translate }}
          </i>
        </li>
      }
    </ul>
  </div>
}
